export const USER = 'user';
export const CUSTOMER = "customer";
export const PERMISSION = "permission";
export const ORDER = "order";
export const PRODUCT = 'product';
export const ECONOMY_ORDER = 'economy_order';
export const BATCH = 'batch';
// export const USER = 'user';